export default class ColumnDefinition {
  id;

  label;

  type;

  sortable = false;

  action;

  sortFunction = (a, b) => this.render(a)?.toString().localeCompare(this.render(b)?.toString());

  constructor({ id, label, type, sortable, action, render, sortFunction }) {
    this.id = id;
    this.label = label;
    this.type = type;
    // Optional vars
    if (action) this.action = action;
    if (sortable) this.sortable = sortable;
    if (render) this.render = render;
    if (sortFunction) this.sortFunction = sortFunction;
  }

  // render is used to take a value from the column and make it into a user-friendly string.
  render(value) {
    return this.format && typeof value === 'number' ? this.format(value) : value;
  }
}
